// Instance
import MainAPI from '@/app/apis/main/main-api.js';

// Endpoints
import { API, ENDPOINTS } from '@/app/apis/main/_connection/connection-api.js';

class AuthenticateAPI extends MainAPI {
	/**
	 * @param {*} pinDetails - Contains web admin's pin details
	 */
	async validatePinCode(pinDetails) {
		return API.post(ENDPOINTS.POST_AUTHENTICATE, pinDetails);
	}
}

export default new AuthenticateAPI();
